import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const BOT_CLASSES = [
  {
    id: 'op',
    title: 'OP BOT',
    subtitleRu: 'Получить права оператора',
    subtitleEn: 'Gain Operator Privileges',
    descRu: 'Проверка разграничения прав доступа, обход матриц разрешений ядра и эскалация привилегий оператора через уязвимые пакеты.',
    descEn: 'Access control audit, kernel permission matrix bypass, and operator privilege escalation via vulnerable packets.',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <polyline points="9 12 11 14 15 10" />
      </svg>
    ),
    watermark: (
      <svg className="bot-card-watermark" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <circle cx="12" cy="11" r="3" />
      </svg>
    ),
  },
  {
    id: 'crash',
    title: 'CRASH BOT',
    subtitleRu: 'Проверить стабильность сервера',
    subtitleEn: 'Test Server Stability',
    descRu: 'Стресс-тестирование тикрейта (TPS), проверка устойчивости планировщика задач ядра к аномальным пакетам и обработке переполнения чанков.',
    descEn: 'Tick rate (TPS) stress testing, scheduler resilience verification against anomalous packets, and chunk overload handling.',
    icon: (
      <svg viewBox="0 0 24 24">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
      </svg>
    ),
    watermark: (
      <svg className="bot-card-watermark" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
      </svg>
    ),
  },
  {
    id: 'account',
    title: 'ACCOUNT BOT',
    subtitleRu: 'Найти пароли аккаунтов',
    subtitleEn: 'Find Account Passwords',
    descRu: 'Анализ стойкости алгоритмов авторизации AuthMe и nLogin, тестирование задержек против параллельных словарных атак и утечек.',
    descEn: 'AuthMe and nLogin algorithm resilience analysis, timing response tests against parallel dictionary attacks and credential dumps.',
    icon: (
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="8" r="5" />
        <path d="M20 21a8 8 0 1 0-16 0" />
        <path d="M16 14v-2a2 2 0 0 1 4 0v2" />
      </svg>
    ),
    watermark: (
      <svg className="bot-card-watermark" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
        <circle cx="12" cy="8" r="5" />
        <path d="M20 21a8 8 0 1 0-16 0" />
        <rect x="14" y="14" width="8" height="7" rx="1.5" />
      </svg>
    ),
  },
];

const BotClassGrid = ({ selectedClass, onSelectClass, disabled = false }) => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  return (
    <section>
      <div className="section-mono-header">
        <div className="section-mono-title">
          <svg viewBox="0 0 24 24" fill="none">
            <rect width="18" height="18" x="3" y="3" rx="2" />
            <path d="M3 9h18M9 21V9" />
          </svg>
          <span>{isEn ? 'SELECT BOT CLASS' : 'ВЫБОР КЛАССА БОТА'}</span>
        </div>
      </div>

      <div className="bot-class-grid">
        {BOT_CLASSES.map((bot) => {
          const isSelected = selectedClass === bot.id;
          return (
            <div
              key={bot.id}
              className={`bot-class-card ${isSelected ? 'selected' : ''} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
              onClick={() => {
                if (!disabled && onSelectClass) {
                  onSelectClass(bot.id);
                }
              }}
            >
              {bot.watermark}

              <div className="bot-card-top">
                <div className="bot-icon-circle">{bot.icon}</div>
                <div className="bot-card-radio">
                  <span className="bot-card-radio-dot"></span>
                </div>
              </div>

              <div className="bot-card-info">
                <h2 className="bot-card-title">{bot.title}</h2>
                <div className="bot-card-subtitle">
                  {isEn ? bot.subtitleEn : bot.subtitleRu}
                </div>
                <p className="bot-card-desc">
                  {isEn ? bot.descEn : bot.descRu}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default BotClassGrid;
